import { render } from "./PartResults.vue?vue&type=template&id=5f132a39"
import script from "./PartResults.vue?vue&type=script&lang=js"
export * from "./PartResults.vue?vue&type=script&lang=js"
script.render = render

export default script